import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 17 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 12\" id=\"filter\"><title>filter</title><path d=\"M16,2H8.82A3,3,0,0,0,3.18,2H1A1,1,0,0,0,1,4H3.18A3,3,0,0,0,8.82,4H16a1,1,0,0,0,0-2ZM6,5A2,2,0,1,1,8,3,2,2,0,0,1,6,5Z\" style=\"fill:#fff\" /><path d=\"M1,10H8.18a3,3,0,0,0,5.64,0H16a1,1,0,0,0,0-2H13.82A3,3,0,0,0,8.18,8H1a1,1,0,0,0,0,2ZM11,7A2,2,0,1,1,9,9,2,2,0,0,1,11,7Z\" style=\"fill:#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol